import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import tick from '../../assets/img/tick.png';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40vw",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: 24,
};

function UniversalModal({ open, onClose, message }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="universal-modal-title"
      aria-describedby="universal-modal-description"
    >
      <Box sx={style}>
        {/* Modal Body */}
        <Box sx={{ padding: "40px", textAlign: "center" }}>
          {/* Success Icon */}
          <Box
            sx={{
              width: "100px",
              height: "100px",
              backgroundColor: "green",
              borderRadius: "50%",
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={tick} alt="Success" style={{ width: "60px", height: "60px" }} />
          </Box>

          {/* Custom Message */}
          <Typography
            sx={{
              marginTop: "20px",
              fontSize: "20px",
              fontWeight: "500",
            }}
          >
            {message || "Operation Successful!"}
          </Typography>

          {/* Home Button */}
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              marginTop: "20px",
              backgroundColor: "#2196F3",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#1976D2",
              },
            }}
          >
            Ok
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default UniversalModal;
